import { useSyncExternalStore } from 'react';
import { readPreference, writePreference } from './config.ts';

// Whether own transfers show in the transaction list: one switch for the list and the count beside
// "Transakcje" in the menu. Kept on this device, like the other interface preferences.
let shown = readPreference('showTransfers') === '1';
const listeners = new Set<() => void>();

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

export function setShowTransfers(next: boolean) {
  shown = next;
  writePreference('showTransfers', next ? '1' : null);
  listeners.forEach((listener) => listener());
}

export function useShowTransfers(): boolean {
  return useSyncExternalStore(subscribe, () => shown);
}
